import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateReminderEmailList(
    $id: String!
    $data: updateReminderEmailListInput!
  ) {
    updateReminderEmailList(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateReminderEmailListRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateReminderEmailListInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'reminder/update_reminder_email_list',
  async (
  params: {id: String;data: TYPES.UpdateReminderEmailListInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateReminderEmailList;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateReminderEmailListSlice = createSlice({
  name: 'update_reminder_email_list',
  initialState: initialState,
  reducers: {
    updateReminderEmailListClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateReminderEmailListRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(
      updateReminderEmailListRequest.fulfilled,
      (state, action) => {
        state.result = action.payload;
        state.loading = false;
      }
    ).
    addCase(updateReminderEmailListRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateReminderEmailListClear } =
updateReminderEmailListSlice.actions;

export const updateReminderEmailList = createSelector(
  (state: RootState) => state.reminder.updateReminderEmailList.result,
  (state: RootState) => state.reminder.updateReminderEmailList.error,
  (state: RootState) => state.reminder.updateReminderEmailList.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateReminderEmailListSlice.reducer;